import {configureStore} from '@reduxjs/toolkit';
import systemInterface from './systemSlice';

export const store = configureStore({
    reducer: {
        system: systemInterface,
    },
});